export default __webpack_public_path__ + "static/jacobs-about-3c97ab837ee271d64d9dddfa7621c601.jpg";